import {
    UPDATEWALLETTRANSACTIONSTATUSPARTNER_SUCCESS,
    UPDATEWALLETTRANSACTIONSTATUSPARTNER_FAILED,
    RESET_UPDATEWALLETTRANSACTIONSTATUSPARTNER,
    LOADING_UPDATEWALLETTRANSACTIONSTATUSPARTNER,
    NETWORK_ERROR_UPDATEWALLETTRANSACTIONSTATUSPARTNER,
} from "../types/index";
import { partnerServices } from "../../config/axios";


const resetUpdateWalletTransactionStatus = () => {
    return { type: RESET_UPDATEWALLETTRANSACTIONSTATUSPARTNER };
};

const getUpdateWalletTransactionStatusLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_UPDATEWALLETTRANSACTIONSTATUSPARTNER });
    await partnerServices
        .post("updateWalletTransactionStatus", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "Success":
                    dispatch(getUpdateWalletTransactionsuccess(res.data));
                    break;
                case "success":
                    dispatch(getUpdateWalletTransactionsuccess(res.data));
                    break;
                default:
                    dispatch(getUpdateWalletTransactionFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_UPDATEWALLETTRANSACTIONSTATUSPARTNER, payload: err });
        });
};
function getUpdateWalletTransactionsuccess(data) {
    return {
        type: UPDATEWALLETTRANSACTIONSTATUSPARTNER_SUCCESS,
        payload: data,
    };
}
function getUpdateWalletTransactionFailed(data) {
    return {
        type: UPDATEWALLETTRANSACTIONSTATUSPARTNER_FAILED,
        payload: data,
    };
}

export { resetUpdateWalletTransactionStatus, getUpdateWalletTransactionStatusLists };
